
import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import styles from './PurchaseSuccess.module.css';

const PurchaseSuccess = () => {
  const { user } = useAuth();
  return (
    <div className={styles.container}>
      <h1>🎉 ご購入ありがとうございます！</h1>
      <p>チケットの購入が正常に完了しました。</p>
      <p>マイページからチケットをご確認いただけます。</p>

      <Link to={user ? '/profile/my' : '/login'} className={styles.button}>
        マイページへ
      </Link>
    </div>
  );
};

export default PurchaseSuccess;
